import MindsetsJsSDK from "../../index";
import {LoadingAction} from "../layout/actions";
import {ErrorMessageAction, SuccessMessageAction} from "../components/CustomToast/actions";
import {EXPRESSION_EQUAL} from "../../constants/filter";

export const LOADED_DISTRICTS = '[districts] Loaded districts';
export const LOADED_DISTRICTS_PAGES = '[districts] Loaded pages';
export const LOADED_DISTRICTS_TOTAL = '[districts] Loaded total';
export const LOADED_DISTRICTS_CURRENT = '[districts] Loaded current';
export const LOADED_DISTRICTS_LIMIT = '[districts] Loaded limit';
export const SET_DISTRICT = '[district] Set district';
export const LOADED_DISTRICT_CHALLENGE_LOCKS = '[district] Loaded Challenge Locks';

export const LoadDistrictsAction = options => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Districts')))
        .then(() => MindsetsJsSDK().API.get('districts', options))
        .then(response => {
            dispatch(LoadedDistrictsAction(response.items));
            dispatch(LoadedDistrictsCurrentAction(response.pages >= response.current ? response.current : 1));
            dispatch(LoadedDistrictsLimitAction(response.limit));
            dispatch(LoadedDistrictsPagesAction(response.pages));
            dispatch(LoadedDistrictsTotalAction(response.total));
            dispatch(LoadingAction(false));

            return response.items;
        })
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const LoadedDistrictsAction = payload => ({
    type: LOADED_DISTRICTS,
    payload
});
export const LoadedDistrictsPagesAction = payload => ({
    type: LOADED_DISTRICTS_PAGES,
    payload
});
export const LoadedDistrictsTotalAction = payload => ({
    type: LOADED_DISTRICTS_TOTAL,
    payload
});
export const LoadedDistrictsCurrentAction = payload => ({
    type: LOADED_DISTRICTS_CURRENT,
    payload
});
export const LoadedDistrictsLimitAction = payload => ({
    type: LOADED_DISTRICTS_LIMIT,
    payload
});

export const DeleteDistrictAction = (district_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.delete(`districts/${district_id}`, options))
        .then(() => dispatch(LoadingAction(false)))
        .then(() => dispatch(SuccessMessageAction('School District has been successfully deleted')))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const LoadDistrictAction = (district_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading School District')))
        .then(() => MindsetsJsSDK().API.get('districts/' + district_id, options))
        .then(response => {
            dispatch(SetDistrictAction(response.district));
            dispatch(LoadingAction(false));

            return response.district;
        })
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const SetDistrictAction = payload => ({
    type: SET_DISTRICT,
    payload
});
export const CreateDistrictAction = (data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Creating a School District')))
        .then(() => MindsetsJsSDK().API.post('districts', data, options))
        .then(response => {
            dispatch(LoadingAction(false));
            dispatch(SuccessMessageAction('A new School District has been created.'));

            return response.district_id;
        });
};
export const UpdateDistrictAction = (id, data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Updating School District')))
        .then(() => MindsetsJsSDK().API.put(`districts/${id}`, data, options))
        .then(() => dispatch(LoadingAction(false)))
        .then(() => dispatch(SuccessMessageAction('School District has been updated.')));
};
export const DeleteSubscriptionAction = (district_id, subscription_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.delete(`districts/${district_id}/subscriptions/${subscription_id}`, options))
        .then(() => dispatch(LoadingAction(false)))
        .then(() => dispatch(SuccessMessageAction('School District Subscription has been successfully archived')))
        .then(() => dispatch(LoadDistrictAction(district_id)))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const CreateSubscriptionAction = (district_id, data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.post(`districts/${district_id}/subscriptions`, data, options))
        .then(() => dispatch(LoadingAction(false)))
        .then(() => dispatch(SuccessMessageAction('School District Subscription has been successfully created')))
        .then(() => dispatch(LoadDistrictAction(district_id)));
};

export const LoadDistrictChallengeLocksAction = (district_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Challenge Locks')))
        .then(() => MindsetsJsSDK().API.get('challenge_locks', Object.assign({}, options, {
            'filters[district_id][0]': EXPRESSION_EQUAL + '=' + district_id
        })))
        .then(response => {
            dispatch(LoadedDistrictChallengeLocksAction(response.items));
            dispatch(LoadingAction(false));

            return response.items;
        })
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const LoadedDistrictChallengeLocksAction = payload => ({
    type: LOADED_DISTRICT_CHALLENGE_LOCKS,
    payload
});
export const CreateDistrictChallengeLocksAction = (district_id, data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Challenge Locks')))
        .then(() => MindsetsJsSDK().API.post(`challenge_locks/${district_id}`, data, options))
        .then(() => dispatch(LoadingAction(false)));
};
export const DeleteChallengeLockAction = (id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.delete(`challenge_locks/${id}`, options))
        .then(() => dispatch(LoadingAction(false)))
        .then(() => dispatch(SuccessMessageAction('Challenge Lock has been deleted')))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
